// Array of data to be displayed on the Timeline module

export const timelineData = [
	{
		title: 'Open source contributions',
		date: 'Now',
		text: 'Working on releasing personal website as a free template and finding security projects to work on, in between Security+ certification studying.',
		techTags: ['react', 'javascript'],
	},
	{
		title: 'Joined RetailMeNot as a Software Engineer',
		date: 'July 2021',
		text: 'Worked with a variety of technologies as part of website backend work, and did a lot of scripting to support legacy functionality. Built internal tooling as well to support cash back operations.',
		techTags: [
			'aws',
			'python',
			'java',
			'javascript',
			'php',
			'laravel',
			'graphql',
			'datadog',
			'okta',
			'kubernetes',
			'sql',
		],
	},
	{
		title: "Graduated from Elmhurst University with Bachelor's degree",
		date: 'May 2021',
		text: 'Double majored in Computer Science and Cyber Security. First to graduate from Elmhurst with the Cyber Security major.',
	},
	{
		title: 'Completed Faculty Activity Reporting System capstone project',
		date: 'May 2021',
		text: 'Created as part of a team of students as part of computer science capstone. Taught other students how to use GitHub in the process.',
		techTags: ['css', 'csharp', 'javascript', 'aspnet'],
		link: {
			url: 'https://github.com/jvkus/FacultyActivityReportingSystem',
			text: 'See the project on GitHub',
		},
	},
	{
		title: 'Worked at iD Tech Camps as an Online Private Instructor',
		date: 'June 2020',
		text: 'Seasonal job; returned as an online instructor, as the pandemic had shut down in-person camps.',
		techTags: ['c++', 'python'],
	},
	{
		title: 'Completed ImageVault capstone project',
		date: 'May 2020',
		text: 'Created in collaboration with another student as part of cyber security capstone. Utilizes steganography techniques to hide and extract data from images.',
		techTags: ['c++', 'qtcreator'],
		link: {
			url: 'https://github.com/jvkus/ImageVault',
			text: 'See the project on GitHub',
		},
	},
	{
		title: 'Worked at iD Tech Camps as a Lead Instructor',
		date: 'May 2019',
		text: 'Returned in a higher position due to high approval ratings from previous season. Taught kids about coding, Linux, computer hardware, breadboard circuits, video editing, and state machines with pi-tops, Anki Cozmo, and Adobe Premiere Pro.',
		techTags: ['c++', 'python', 'premiere'],
		link: {
			url: 'https://www.pi-top.com/',
			text: "What's a pi-top?",
		},
	},
	{
		title: 'Worked at iD Tech Camps as an Instructor',
		date: 'May 2021',
		text: 'Seasonal job. Taught kids about coding, Linux, computer hardware, breadboard circuits, and C++ with pi-tops and Visual Studio. First experience with designing lesson plans.',
		techTags: ['c++', 'python'],
		link: {
			url: 'https://www.idtech.com/',
			text: 'Learn about iD Tech',
		},
	},
];
